export default "__VITE_ASSET__850f5317__"